export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCXFNeyV-YIRsG5OusG-3KjcvnIm137_xQ",
  authDomain: "mega-delivery-dz.firebaseapp.com",
  projectId: "mega-delivery-dz",
  storageBucket: "mega-delivery-dz.firebasestorage.app",
  messagingSenderId: "389762346589",
  appId: "1:389762346589:web:e8fdc47cc5d54fdc00a7b4"
  },
  // firebaseApiUrl: 'http://127.0.0.1:5001/your_project_name/us-central1/',
  // firebaseApiUrl: 'http://127.0.0.1:5001/mega-pizza-delivery/eur3/', // for local, and for real app replace whole url with server url

  // googleMapsApiKey: 'AIzaSyDWY_C-BzEiL_FhJ9n1-cv2JVqC3rpa2cA',
  nativeAuthCustomTokenUrl: 'https://nativeauthcustomtoken-ow4mxlpraq-ew.a.run.app',
  appCheckSiteKey: '6Lfa7jUsAAAAAMXj6HKLpeESOTUGUQQDMB36IlIq',

  // ✅ Web Push VAPID Key (Firebase Console -> Project Settings -> Cloud Messaging)
  webPushVapidKey: "BEz31GHDjiqZozpbdaN7w4Zcc1bQB_DCkr7glj6qbsI-AmTuT9xV1uMcHJohhqYUwgt_CymVKm0cqkoKEQ4RgcA",
  appKey: 'customer',

  stripe: {
    publishableKey: '',
    secretKey: '',
    apiBaseUrl: 'https://api.stripe.com/v1/',
  },

  razorpay: {
    key_id: '',
    key_secret: ''
  },

  // user
  oneSignalUser: {
    appId: '',
    restApiKey: '',
    android_channel_id: '',
  },

  // restaurant
  oneSignalRestaurant: {
    appId: '',
    restApiKey: '',
    android_channel_id: '',
  },

  // rider
  oneSignalRider: {
    appId: '',
    restApiKey: '',
    android_channel_id: '',
  },

  CountryJson: [
    { name: 'Afghanistan', dial_code: '+93', code: 'AF' },
    { name: 'Albania', dial_code: '+35', code: 'AL' },
    { name: 'Algeria', dial_code: '+213', code: 'DZ' },
    { name: 'AmericanSamoa', dial_code: '+1 684', code: 'AS' },
    { name: 'Andorra', dial_code: '+376', code: 'AD' },
    { name: 'Angola', dial_code: '+244', code: 'AO' },
    { name: 'Anguilla', dial_code: '+1 264', code: 'AI' },
    { name: 'Antigua and Barbuda', dial_code: '+1268', code: 'AG' },
    { name: 'Argentina', dial_code: '+54', code: 'AR' },
    { name: 'Armenia', dial_code: '+374', code: 'AM' },
    { name: 'Aruba', dial_code: '+297', code: 'AW' },
    ]
};
